import { render, staticRenderFns } from "./SafraList.vue?vue&type=template&id=0e3e8e60&scoped=true"
import script from "./SafraList.vue?vue&type=script&lang=js"
export * from "./SafraList.vue?vue&type=script&lang=js"
import style0 from "./SafraList.vue?vue&type=style&index=0&id=0e3e8e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e8e60",
  null
  
)

export default component.exports